import { Sparkle } from "lucide-react";

const ITEMS = [
  "Webdesign",
  "Logo Design",
  "Local SEO",
  "Branding",
  "Online-Shops",
  "Google Ads",
  "Corporate Identity",
  "Web-Apps",
  "Social Media",
  "Print Design",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative overflow-hidden border-y border-white/10 bg-[#0A0A0A] py-5" data-testid="marquee-strip">
      <div className="flex w-max animate-marquee items-center gap-10">
        {row.map((item, i) => (
          <div key={`${item}-${i}`} className="flex items-center gap-10">
            <span className="font-heading text-xs font-semibold uppercase tracking-wider text-muted-foreground">
              {item}
            </span>
            <Sparkle className="h-3.5 w-3.5 text-[#C5A059]" />
          </div>
        ))}
      </div>
    </div>
  );
};
